import useRequest, {
    RequestKeys,
    RequestFn,
} from 'app/hooks/useRequest'
import {
    ChangeRequestApprovalType,
} from 'app/Apps/OrderManagement/Orders/orders.types'
import changeRequestApprovalRequests from 'app/requests/Order/ChangeRequestApproval.requests'

const useGetChangeRequestApproval = (orderNumber: string) => {
    return useRequest<ChangeRequestApprovalType>({
        key: RequestKeys.getChangeRequestApproval,
        params: {
            orderNumber,
        },
        requestFunc: RequestFn.getEntity(changeRequestApprovalRequests.getChangeRequestApproval),
        enabled: Boolean(orderNumber),
        keepPreviousData: true,
    })
}

export default useGetChangeRequestApproval
